import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import {computed, inject} from "vue";
import Swal from "sweetalert2";

export default function useLanderHelper(conf) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const getters = store.getters;
    const step = computed(() => {
        return parseInt(route.params.step || '1');
    });

    function scrollToElement(selector) {
        if (!selector || !selector instanceof Object) {
            return;
        }
        let element = null;
        if (selector.id) {
            if (selector.id.substring(0, 1) == "#") {
                selector.id = selector.id.substring(1);
            }
            element = document.getElementById(selector.id);
        } else if (selector.query) {
            element = document.querySelector(selector.query);
        }
        if (element) {
            store.commit('setScrollTrackingPaused', true);
            setTimeout(function () {
                element.scrollIntoView({behavior: 'smooth'});
            }, 100);
            setTimeout(function () {
                store.commit('setScrollTrackingPaused', false);
            }, 1000);
        }
    }

    function serverLog(data) {
        data = {'product': getters.product.code, ...route.query, ...getters.options, ...data};
        if (data['action'] === undefined) {
            console.error('server log method missing action');
            return;
        }
        if (data.autht){
            delete data.autht;
        }

        if (data.sid && data.sid.includes(";")) {
            let sid_parts = data.sid.split(";");
            data.sid = sid_parts[0];
        }
        return store.dispatch('serverLog', data)
    }

    function trackClick(elementName, data = {}) {
        serverLog({
            ...data,
            action: 'lander_action',
            user_action: `Clicked on ${elementName}`
        });
    };

    function logInputFocus(inputName) {
        serverLog({
            action: 'lander_action',
            user_action: 'Input off focus',
            input_name: inputName,
            step: step.value,
        });
    };

    function nextStep(nextRoute) {
        nextRoute = {
            name: route.name,
            hash: route.hash,
            params: {...route.params, step: step.value + 1},
            query: route.query,
            ...nextRoute
        };
        if (shiftDomain()) {
            store.commit('disableUnloadHandler');
            nextRoute.query = {...nextRoute.query, 'prospectId': getters.prospect.prospectId}
            let props = router.resolve(nextRoute);
            let redirectUrl = window.location.protocol + '//' + getters.product.domain + props.href;
            window.location = redirectUrl;
        } else {
            router.push(nextRoute);
        }
    }

    function showError(message, code) {
        if(!message) {
            message = "Unknown Error";
        }
        if(code == 9001) { //Duplicate subscription
            store.commit('disableUnloadHandler');
            Swal.fire({
                html: message,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: true,
                confirmButtonText:'Continue to Login'
            }).then((result) => {
                if (result.value) {
                    window.location.href = "/";
                }
            });
        } else {
            Swal.fire({
                icon: 'error',
                text: message,
            })
        }
    }

    function showMsg(title, message) {
        Swal.fire({
            icon: 'info',
            title: title,
            text: message,
            showConfirmButton: false,
            timer: 10000
        });
    }

    function shiftDomain() {
        if(!getters?.product?.domain) {
            return false;
        }
        let currentDomain = location.host.replace('www.', '');
        let expectedDomain = getters.product.domain.replace('www.', '');
        return currentDomain != expectedDomain;
    }

    function createSessionFrame(sessionUrl) {
        const iframe = document.createElement("iframe");
        iframe.src = sessionUrl.toString();
        iframe.setAttribute("height", 0);
        iframe.setAttribute("width", 0);
        iframe.setAttribute("style", 'display: none; visibility: hidden;');

        document.body.appendChild(iframe);
    }


    return {scrollToElement, serverLog, trackClick, logInputFocus, nextStep, showMsg, showError, shiftDomain, createSessionFrame};
}

